// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"dac624ed","254":"4ca16dbd","453":"68693753","584":"a82a4745","595":"45a10a32","607":"be5d4f9a","737":"230df0d2","828":"3c0b5f5d"}[chunkId] + ".chunk.js";
};